<template>
  <div>
    <div class="row mb-3 align-items-center">
      <div v-if="searchKeys" class="col-md-4 mb-2">
        <b-form-input v-model.trim="query" size="sm" :placeholder="searchPlaceholder" />
      </div>
      <div v-if="sortOptions.length" class="col-md-3 mb-2">
        <b-form-select v-model="sortValue" size="sm" :options="selectSortOptions" />
      </div>
      <div class="col-auto mb-2">
        <b-form-select v-model.number="perPage" size="sm" :options="pageSizeOptions" />
      </div>
      <slot name="controls"></slot>
      <div class="col mb-2 text-md-right text-muted" style="font-size:12px">
        Showing {{ totalRows }} of {{ items.length }} {{ noun }}
      </div>
    </div>

    <slot :rows="pagedRows" :total="totalRows"></slot>

    <div v-if="pageCount > 1" class="d-flex justify-content-end mt-2">
      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" size="sm" class="mb-0" />
    </div>
  </div>
</template>

<script>
export default {
  name: "DataList",
  props: {
    items: { type: Array, required: true },
    searchKeys: { type: Function, default: null },
    sortOptions: { type: Array, default: () => [] },
    value: { type: String, default: "" },
    pageSizes: { type: Array, default: () => [10, 25, 50] },
    initialPageSize: { type: Number, default: 10 },
    searchPlaceholder: { type: String, default: "Search…" },
    noun: { type: String, default: "items" },
  },
  data() {
    return {
      query: this.value,
      sortValue: this.sortOptions.length ? this.sortOptions[0].value : "",
      perPage: this.initialPageSize,
      currentPage: 1,
    }
  },
  computed: {
    filtered() {
      const q = (this.query || "").toLowerCase().trim()
      if (!q || !this.searchKeys) return this.items
      return this.items.filter((item) => {
        const haystack = (this.searchKeys(item) || []).join(" ").toLowerCase()
        return haystack.indexOf(q) !== -1
      })
    },
    activeSort() {
      return this.sortOptions.find((option) => option.value === this.sortValue) || null
    },
    sorted() {
      if (!this.activeSort || typeof this.activeSort.compare !== "function") return this.filtered
      return this.filtered.slice().sort(this.activeSort.compare)
    },
    totalRows() {
      return this.sorted.length
    },
    pageCount() {
      return Math.max(1, Math.ceil(this.totalRows / this.perPage))
    },
    pagedRows() {
      const start = (this.currentPage - 1) * this.perPage
      return this.sorted.slice(start, start + this.perPage)
    },
    selectSortOptions() {
      return this.sortOptions.map((option) => ({ value: option.value, text: option.text }))
    },
    pageSizeOptions() {
      return this.pageSizes.map((size) => ({ value: size, text: size + " per page" }))
    },
  },
  watch: {
    value(next) {
      this.query = next
    },
    query(next) {
      this.currentPage = 1
      this.$emit("input", next)
    },
    sortValue() {
      this.currentPage = 1
    },
    perPage() {
      this.currentPage = 1
    },
    pageCount(next) {
      if (this.currentPage > next) this.currentPage = next
    },
  },
}
</script>
